module.exports = __webpack_public_path__ + "img/honors-college.8d8a1394.jpg";